"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MysticBoltAbilityHandler = exports.MysticBoltActorAbilityFactory = exports.MysticBoltAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const enums_1 = require("../../core/enums");
const Random_1 = require("../../utils/Random");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class MysticBoltAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.MysticBolt;
        this.__typeName = "MysticBolt";
    }
}
exports.MysticBoltAbilityArgs = MysticBoltAbilityArgs;
let MysticBoltActorAbilityFactory = class MysticBoltActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("MysticBolt", "OneEnemies", 0);
    }
};
MysticBoltActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("MysticBolt")
], MysticBoltActorAbilityFactory);
exports.MysticBoltActorAbilityFactory = MysticBoltActorAbilityFactory;
let MysticBoltAbilityHandler = class MysticBoltAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Chaos", 45)
            ],
            projectileType: "CyanHauntedProjectile",
            projectilePath: "line",
            onHit: sequence => {
                const effect = (0, Random_1.randomWeightedElement)([
                    {
                        weight: 25,
                        value: new core_1.LinkedEffectsEffectArgs([
                            enums_1.AttributeType.NatureDamageImmunity,
                            enums_1.AttributeType.FireDamageImmunity,
                            enums_1.AttributeType.FrostDamageImmunity,
                            enums_1.AttributeType.SonicDamageResistance,
                        ].map(attr => new core_1.MaxAttributeDecreaseEffectArgs(attr, 2)), true)
                    },
                    {
                        weight: 50,
                        value: new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.AllDamageImmunity, 1)
                    },
                    {
                        weight: 25,
                        value: undefined
                    }
                ]);
                if (!effect) {
                    return;
                }
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(4),
                    effect
                });
            }
        });
    }
};
MysticBoltAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.MysticBolt)
], MysticBoltAbilityHandler);
exports.MysticBoltAbilityHandler = MysticBoltAbilityHandler;
